import * as React from 'react';
import { resolveAction, createHref, parseAction } from 'retil-history';
export var Redirect = function (props) {
    throw Promise.resolve(props.redirectPromise);
};
export function routeRedirect(to, status) {
    if (status === void 0) { status = 302; }
    return function (fromRequest, response) {
        var toAction = parseAction(typeof to === 'function' ? to(fromRequest) : to);
        var href = createHref(resolveAction(toAction, fromRequest.basename));
        // Defer this promise until we're ready to actually render the content
        // that would have existed at this page.
        var redirectPromise;
        var lazyPromise = {
            then: function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                redirectPromise = redirectPromise || response.redirect(status, href);
                return redirectPromise.then.apply(redirectPromise, args);
            },
        };
        response.pendingSuspenses.push(lazyPromise);
        return React.createElement(Redirect, { redirectPromise: lazyPromise });
    };
}
